import styles from 'new/components/header/Header.module.scss';
import { Popover, Typography } from '@mui/material';
import UserDropdown from 'new/components/userDropdown/UserDropdown';
import React, { MouseEventHandler, useCallback } from 'react';
import { ProfileImage } from 'new/elements/ProfileImage';
import { useSelector } from 'react-redux';
import { getCurrentUser } from 'js/reducers/session';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import cx from 'classnames';

export function ProfileAction() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  }, []) as MouseEventHandler<HTMLDivElement>;

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setOpen(false);
  }, []);

  const currentUser = useSelector(getCurrentUser);
  const org = useCurrentOrg();
  const session = useSelector((state: any) => state.session);
  const gProfile = session?.googleAuth?.profile;
  return (
    <>
      <div
        onClick={handleOpen}
        aria-describedby="user-dropdown"
        className={cx(styles.avatarBlock, !!anchorEl ? styles.avatarBlockOpen : undefined)}
      >
        <Typography variant="subtitle2" className={styles.avatarOrg}>
          {org.name}
        </Typography>
        <ProfileImage
          size="xxsmall"
          source={gProfile?.email === currentUser?.email ? gProfile?.getImageUrl() : undefined}
          fullName={currentUser?.full_name}
        />
      </div>
      <Popover
        open={open}
        PaperProps={{
          className: styles.popover,
          sx: {
            borderRadius: '12px',
          },
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <UserDropdown />
      </Popover>
    </>
  );
}
